import { defineComponent as _defineComponent } from 'vue'
import { toRefs, type DefineComponent } from 'vue';

interface Props {
    tag?: string | DefineComponent,
    theme?: 'light' | 'dark',
    nested?: boolean,
    mobileFont?: boolean,
    desktopFont?: boolean,
    responsiveFont?: boolean,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'Container',
  props: {
    tag: { default: 'li' },
    theme: null,
    nested: { type: Boolean, default: false },
    mobileFont: { type: Boolean, default: false },
    desktopFont: { type: Boolean, default: false },
    responsiveFont: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { tag: string | DefineComponent, theme?: 'light' | 'dark', nested: boolean, mobileFont: boolean, desktopFont: boolean, responsiveFont: boolean };

;



const {
    theme,
    tag,
    nested,
    mobileFont,
    desktopFont,
    responsiveFont,
} = toRefs(props);

return { __sfc: true,props, theme, tag, nested, mobileFont, desktopFont, responsiveFont }
}

})